import { axiosInstance } from "../../utils/axios";
import { Dataset } from "../models/dataset";
import { getVersionedApiUrl } from "../../utils/helpers/ApiResolver";

export function fetchDatasets(dbId: string, awCode: string, descriptionLanguage: string): Promise<Dataset[]> {
  return axiosInstance
    .get(`${getVersionedApiUrl("/datasets")}/${dbId}/${awCode}?descriptionLanguage=${descriptionLanguage}`)
    .then((response) => response.data);
}
